import axios from "@/libs/api.request";
import { getToken } from "@/libs/util";
// 获取列表
export const getList = params => {
  return axios.request({
    url: "/shipments/switchDeliverAgent",
    params,
    method: "get"
  });
};
// 创建列表
export const add = data => {
  return axios.request({
    url: "/shipments/switchDeliverAgent",
    data,
    method: "post"
  });
};

export const uploadFile = data => {
  return axios.request({
    url: `/shipments/switchDeliverAgent/upload`,
    method: "post",
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: getToken()
    },
    data
  });
};